import React from "react";
import { Container, Image, Grid, Responsive } from "semantic-ui-react";
import { logoEsr, logoCasasAra, logoConsorciosAra } from "../assets/Assets";

class FooterCompo extends React.Component{
    renderInMobile() {
        return (
            <Container textAlign="center" 
            style={{
                marginBottom:"120px",
                marginTop:"88px"
            }}>
            <Grid centered columns={2} textAlign="center">
                <Grid.Column centered textAlign="center">
                    <Image src={logoCasasAra} width={153} heigth={55} 
                    style={{
                        margin:"0 auto"
                    }}/>
                </Grid.Column>
                <Grid.Column textAlign="center">
                    <Image src={logoConsorciosAra} width={192} heigth={62} 
                    style={{
                        margin:"0 auto"
                    }}/>
                </Grid.Column>
            </Grid>
            <div
            style={{
                marginTop:"56px",
                marginBottom:"20px"
            }}>
            <p
                style={{
                fontStyle:"italic",
                fontSize:"15px",
                fontFamily:"Lato"
            }}
            >2018 © Derechos Reservados Consorcio ARA</p>
            </div>

            </Container>
        );
    }

    renderInTablet() {
        return (
            <Container textAlign="center" 
            style={{
                marginBottom:"120px",
                marginTop:"88px"
            }}>

            <Grid centered columns={6} textAlign="center">
                <Grid.Column>
                    <Image src={logoCasasAra} width={153} heigth={55} />
                </Grid.Column>
                <Grid.Column>
                    <Image src={logoConsorciosAra} width={192} heigth={62} />
                </Grid.Column>
            </Grid>
            <div
            style={{
                marginTop:"56px",
                marginBottom:"20px"
            }}>
            <p
                style={{
                fontStyle:"italic",
                fontSize:"15px",
                fontFamily:"Lato"
            }}
            >2018 © Derechos Reservados Consorcio ARA</p>
            </div>

            </Container>
        );
    }

    renderInDesktop() {
        return (
            <Container textAlign="center" 
            style={{
                marginBottom:"120px",
                marginTop:"120px"
            }}>

            <Grid centered columns={6} textAlign="center">
                <Grid.Column>
                    <Image src={logoCasasAra} width={153} heigth={55} />
                </Grid.Column>
                <Grid.Column>
                    <Image src={logoConsorciosAra} width={192} heigth={62} />
                </Grid.Column>
            </Grid>
            <div
            style={{
                marginTop:"56px",
                marginBottom:"20px"
            }}>
            <p
                style={{
                fontStyle:"italic",
                fontSize:"15px",
                fontFamily:"Lato"
            }}
            >2018 © Derechos Reservados Consorcio ARA</p>
            </div>

            </Container>
        );
    }

    render() {
        return (
          <div>
            <Responsive {...Responsive.onlyMobile}>
              {this.renderInMobile()}
            </Responsive>
            <Responsive {...Responsive.onlyTablet}>
              {this.renderInTablet()}
            </Responsive>
            <Responsive {...Responsive.onlyComputer}>
              {this.renderInDesktop()}
            </Responsive>
          </div>
        );
      }
}

export default FooterCompo;